import React from 'react';
import { makeStyles, CssBaseline, Link } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
//import MoreIcon from '@material-ui/icons/MoreVert';
//import InputLabel from '@material-ui/core/InputLabel';
//import FormHelperText from '@material-ui/core/FormHelperText';
import SearchIcon from '@material-ui/icons/Search';
import {isMobileOnly , isMobile} from 'react-device-detect'
import App from "./navbar"

const barWidth = () => {
  if (isMobile) return   '100vw'
  else return '70vw'
}

const logoImg = () => {
  if (isMobileOnly) return './logofull.png'
  else return './bim192.png'
}

const renderWidth = () => {
  if (isMobileOnly) return '26vw'
  else return '18vw'
}

const renderHeight = () => {
  if (isMobileOnly) return '11vh'
  else return '11vh'
}

const textSize = () => {
  if (isMobileOnly) return 12
  else return 16
}

const useStyles = makeStyles(theme => ({

    grow: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      color: 'red',
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
      fontFamily: 'Pacifico',
      fontStyle: 'oblique'
    },
   
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },

    ContentBackground:{
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#282c34',
      height: renderHeight(),
      display: 'flex',
      width:'100vw',
      verticalAlign: 'middle',
      flexDirectison: 'columns',
      margin: 0,
      padding: 0,
    },

    roots:{
      width: barWidth(),
      justifyContent: 'center',
      height: renderHeight(), 
      display: 'flex',
      verticalAlign: 'middle',
      flexDirectison: 'columns',
      margin: 0,
      padding: 0
    },

    formControl: {
      margin: theme.spacing(0.5),
      minWidth: renderWidth(),
    },
  }));


function TopHeader({cartEmpty, returnSeller, address, getAddress, removeContent}) {

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = event => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
        <a
            style ={{color:"inherit", display:"inherit"}}
            href= "https://www.facebook.com/bimbimsnackoz/"
            target="_blank"
            rel="noopener noreferrer"
        >
            <MenuItem>
            <IconButton aria-label="facebook" color="inherit">
                < FacebookIcon/>
            </IconButton>
            <p>Facebook</p>
            </MenuItem>
        </a>

        <a
            style ={{color:"inherit", display:"inherit"}}
            href= "https://www.instagram.com/bimbimsnackoz/"
            target="_blank"
            rel="noopener noreferrer"
        >
            <MenuItem>
            <IconButton aria-label="instagram" color="inherit">
                <InstagramIcon />
            </IconButton>
            <p>Instagram</p>
            </MenuItem>
        </a>
    </Menu>
  );

  return (
    <div className = {classes.ContentBackground}>
      <div className = {classes.roots}>
      <AppBar position = 'static' className ={classes.roots} style={{backgroundColor:'white'}}  >
        <Toolbar position = 'static' >
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="open drawer"
            style = {{backgroundColor:'transparent'}}>   
            <Link href="https://bimbim-pwa.firebaseapp.com/" onClick={event => event.preventDefault} color='inherit'>
              <img src = {logoImg()} style ={{height: '8vh'}} alt ={'Error'} />
            </Link>
          </IconButton>

          <Typography className={classes.title} variant="h4" noWrap>
            <Link href="https://bimbim-pwa.firebaseapp.com/" onClick={event => event.preventDefault} color='inherit' style={{textDecoration:'none'}}>
              BimBim
            </Link>
          </Typography>

          <div className={classes.grow}/>
          
            <App isEmpty = {cartEmpty} inputValue={address}  setInputValue={getAddress} removeContent={removeContent}/>

            <div className={classes.grow}/>

            <IconButton onClick={returnSeller()}>
              <SearchIcon />
            </IconButton>
          
        <div className={classes.grow}/>
          <div className={classes.sectionDesktop}>
            <IconButton aria-label="show 4 new mails" color="primary">
                <a
                    style ={{color:"inherit", display:"inherit"}}
                    href= "https://www.facebook.com/bimbimsnackoz/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                  < FacebookIcon fontSize='large'/>
                </a>
            </IconButton>
            <IconButton aria-label="show 17 new notifications" color="primary">
                <InstagramIcon fontSize ='large' />
            </IconButton>
          </div>
          
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      <CssBaseline/>
      </div>
    </div>
  );
}

export default TopHeader;